var React = require('react');

function PaginationChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.64 5.232a1 1 0 0 1 .128 1.408L10.302 12l4.466 5.36a1 1 0 1 1-1.536 1.28l-5-6a1 1 0 0 1 0-1.28l5-6a1 1 0 0 1 1.408-.128Z","fill":"#1D191F"}));
}

PaginationChevronLeft.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = PaginationChevronLeft;

PaginationChevronLeft.default = PaginationChevronLeft;
